/* Snoofle: AJAX add-to-basket -> opens cart drawer (upsell buttons + range cards) */
(function () {
  if (window.__snfCart) return; window.__snfCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function add(id, qty, btn) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return false;
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { alert(res.description || res.message); return; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
    }).catch(function () { window.location.href = root + 'cart'; })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
    return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-snf-add]');
    if (!b) return;
    e.preventDefault();
    if (!add(b.getAttribute('data-snf-add'), 1, b)) window.location.href = root + 'cart';
  });
})();
